
import { checkActionAttribute } from "../../jobs-flow/modal-actions/checkActionAttribute";
export const systemEmailsModalActionsListners = (target, actionsWindow) => {
    const campaign_id = $(target).data('id');
    const email_id = $(target).data('email_id');
    const email_type = 'system';
    const status = $(target).data('status');
    const system_type = $(target).data('system_type') ?? null;

    checkActionAttribute([
        { attribute: 'editable',    className: 'edit_email' },
        { attribute: 'switch-status',     className: 'update_system_email_status' },
        { attribute: 'test-available',     className: 'test_email_btn' },
        // { attribute: 'data-not-verified',   className: 'verify' },
    ], target, actionsWindow);

    actionsWindow.find('#view_email_modal_btn').data('email_id', email_id).data('system_type', system_type).data('campaign_id', campaign_id);
    if (status == 0) {
        $('.update_system_email_status').data('campaign_id', campaign_id).data('status_id',1).text('Activate');
    }else{
        $('.update_system_email_status').data('campaign_id', campaign_id).data('status_id',0).text('Pause');
    }
    actionsWindow.find('.edit_email').attr('href', `/email-department/email-designing-text?email_id=${email_id}&campaign_id=${campaign_id}&email_type=${email_type}`);
    actionsWindow.find('.test_email_btn').data('email_id', email_id);
}
